import { Row, Col, Card, Button, Input, Form, Skeleton, Image, Select, Radio, InputNumber, Tooltip, Tag } from "antd";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import { useNavigate } from "react-router";
import apiPath from "../../../constants/apiPath";
import DescriptionEditor from '../../../components/DescriptionEditor'
import SingleImageUpload from "../../../components/SingleImageUpload";
import MultipleImageUpload from "../../../components/MultipleImageUpload";
import notfound from "../../../assets/images/not_found.png";

function Edit() {

    const sectionName = "Product";
    const routeName = "product/catalogue";

    const api = {
        addEdit: apiPath.addEditProduct,
        // brand: apiPath.listBrand,
        category: apiPath.categoryList,
        edit: apiPath.editProduct,
    }

    const [form] = Form.useForm();
    const { request } = useRequest()
    const params = useParams();
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const [editorValue, setEditorValue] = useState('');
    const FileType = ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/gif"]
    const [image, setImage] = useState([]);
    const [file, setFile] = useState([]);
    const [variantList, setVariantList] = useState([])
    const [makeList, setMakeList] = useState([])
    const [modelList, setModalList] = useState([])
    const [categoryList, setCategoryList] = useState([])
    const [years, setYears] = useState([])
    const [multipleImage, setMultipleImage] = useState([]);

    const getCategoryList = () => {
        request({
            url: api.category + "/" + 'product',
            method: 'GET',
            onSuccess: (data) => {
                setCategoryList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    };

    const handleImage = (data) => {
        setImage(data);
    }

    const getMakeList = () => {
        request({
            url: '/common/make',
            method: 'GET',
            onSuccess: (data) => {
                setMakeList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const getModalList = (id) => {
        request({
            url: `/common/model/${id}`,
            method: 'GET',
            onSuccess: (data) => {
                setModalList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const getVariantList = (id) => {
        request({
            url: `/common/variant/${id}`,
            method: 'GET',
            onSuccess: (data) => {
                setVariantList(data.data);
            },
            onError: (error) => {
                console.log(error)
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const fetchData = (id) => {
        request({
            url: api.edit + "/" + id,
            method: 'GET',
            onSuccess: ({ data, status }) => {
                setLoading(false);
                form.setFieldsValue(data)
                setEditorValue(data.description);
                setFile([data.thumbnail])
                // setImage(data.thumbnail)
                data.make_id && getModalList(data.make_id)
                data.model_id && getVariantList(data.model_id)
                setMultipleImage(data.image && data.image.length > 0 && data.image.map(item => ({ url: item })))
            },
            onError: (error) => {
                ShowToast(error, Severty.ERROR)
            }
        })
    }

    const handleMultipleImage = (data) => {
        setMultipleImage(data);
    }

    const handleMultipleDeleteImage = (data) => {
        setMultipleImage(prevFileList => prevFileList.filter(item => item.url !== data));
    }

    const handleEditorChange = (data) => {
        setEditorValue(data);
    }

    const OnUpdate = (values) => {
        if (editorValue.trim() === '<p></p>' || editorValue.trim() === "") return ShowToast('Please Enter Description', Severty.ERROR)
        const { name, part_number, /* brand_id, */ price, category_id, is_featured, make_id, model_id, year_model, variant_id, sku } = values
        const payload = {};
        payload.price = price;
        payload.name = name;
        payload.part_number = part_number;
        payload.category_id = category_id;
        payload.thumbnail = image.length > 0 ? image[0].url : null;
        payload.description = editorValue;
        payload.is_featured = is_featured;
        payload.make_id = make_id;
        payload.model_id = model_id;
        payload.year_model = year_model;
        payload.variant_id = variant_id;
        payload.sku = sku;
        payload.image = multipleImage ? [...multipleImage?.map((item) => item.url)] : []
        setLoading(true)
        request({
            url: api.addEdit + "/" + params.id,
            method: 'POST',
            data: payload,
            onSuccess: (data) => {
                setLoading(false)
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS)
                    navigate(`/pimptup-admin/${routeName}`);
                } else {
                    ShowToast(data.message, Severty.ERROR)
                }
            },
            onError: (error) => {
                ShowToast(error.response.data.message, Severty.ERROR)
                setLoading(false)
            },
        })
    };
    
    useEffect(() => {
        let years = [];
        for(let i=1990; i < new Date().getFullYear(); i++){
            years.push(i);
        }
        setYears(years);
    }, [])
    
    useEffect(() => {
        setLoading(true)
        fetchData(params.id);
        getCategoryList();
        getMakeList()
    }, [])

    return (

        <Card title={"Update " + sectionName}>
            {loading ? [1, 2, 3, 4].map(item => <Skeleton active key={item} />) :
                <Form className="edit-page-wrap colPadding" form={form} onFinish={OnUpdate} autoComplete="off" layout="verticle" name="catalogue_form">
                    <Row gutter={[24, 0]}>
                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item normalize={value => value.trimStart()} label="Name" name="name" rules={[{ required: true, message: "Missing name!" }]}>
                                <Input autoComplete="off" placeholder="Enter Product Name" />
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item

                                normalize={value => value.trimStart()} label="Sku" name="sku"
                                rules={[{ required: true, message: "Missing the sku!" },
                                { max: 15, message: "Name must contain minimum 4 and maximum 15 characters " },
                                { min: 4, message: "Name must contain minimum 4 and maximum 15 characters " }
                                ]}>
                                <Input disabled autoComplete="off" placeholder="Enter Product SKU" />
                            </Form.Item>
                        </Col>
                        {/* </Row> */}

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="category-elt"
                                name="category_id"
                                label="Select Category"
                                rules={[{ required: true, message: 'Missing Category Selection' }]}
                            >

                                <Select placeholder="Select Category">
                                    {categoryList && categoryList.length > 0 ? categoryList.map((item, index) => (
                                        <option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </option>
                                    )) : null}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="make-elt"
                                name="make_id"
                                label="Select Make"
                                rules={[{ required: true, message: 'Missing Make Selection' }]}
                            >
                                <Select
                                    placeholder="Select Make"
                                    onChange={(make) => getModalList(make)}
                                >
                                    {makeList.map((item, index) => (
                                        <Select.Option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="model-elt"
                                name="model_id"
                                label="Select Model"
                                rules={[{ required: true, message: 'Missing Model Selection' }]}
                            >
                                <Select
                                    placeholder="Select Model"
                                    onChange={(model) => getVariantList(model)}
                                >
                                    {modelList.map((item, index) => (
                                        <Select.Option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="model-elt"
                                name="variant_id"
                                label="Select Variant"
                                rules={[{ required: true, message: 'Missing Variant Selection' }]}
                            >
                                <Select placeholder="Select Variant">
                                    {variantList.map((item, index) => (
                                        <Select.Option key={index} value={item._id}>
                                            <span className="cap">{item.name}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item className="model-elt"
                                name="year_model"
                                label="Select Model Year"
                                rules={[{ required: true, message: 'Missing Model Year' }]}
                            >
                                <Select placeholder="Select Model Year">
                                    {years.map((item, index) => (
                                        <Select.Option key={index} value={item}>
                                            <span className="cap">{item}</span>
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item normalize={value => value.trimStart()} label="Part Number" name="part_number"
                                rules={[{ required: true, message: "Missing part number!" },
                                { max: 15, message: "Part Number contain minimum 4 and maximum 15 characters " },
                                { min: 4, message: "Part Number contain minimum 4 and maximum 15 characters " }]}
                            >
                                <Input maxLength={80} autoComplete="off" placeholder="Enter Part Number" />
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item

                                label="Base price"
                                name="price"
                                rules={[{ required: true, message: "Missing the price!" },

                                ]}
                            >
                                <InputNumber maxLength={10} autoComplete="off" placeholder="Enter Base price" />
                            </Form.Item>
                        </Col>

                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item label="Mark as Featured" name="is_featured">
                                <Radio.Group>
                                    <Radio value={true}>Yes</Radio>
                                    <Radio value={false}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        {/* </Row>

                    <Row gutter={[24, 0]}> */}
                        <Col span={24} sm={12} md={8} lg={12} xl={8} xxl={6}>
                            <Form.Item
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (value !== undefined && value?.length > 0) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Missing Image!'));
                                        },
                                    }
                                ]}
                                label="Upload Thumbnail" name="thumbnail">
                                <SingleImageUpload
                                    value={image}
                                    fileType={FileType}
                                    imageType={'product'}
                                    btnName={'Thumbnail'}
                                    onChange={(data) => handleImage(data)} />
                            </Form.Item>
                            {file && file.length > 0 && <div className="mt-2"> <Image width={120} src={file !== "" ? file : notfound}></Image> </div>}
                        </Col>

                        <Col span={24}>
                            <Form.Item label="Upload Other Image" name="image">
                                <div className="mt-1 otherImages">
                                    <MultipleImageUpload data={multipleImage && multipleImage.length > 0 ? [...multipleImage.map((item) => item.url)] : []} fileType={FileType} imageType={'product'} btnName={'Image'} onDelete={(data) => handleMultipleDeleteImage(data)} onChange={(data) => handleMultipleImage(data)} />
                                </div>
                            </Form.Item>
                        </Col>

                        <Col md={24}>
                            <Form.Item label="Description" name="description">
                                <DescriptionEditor value={editorValue} placeholder="Enter Product Description" onChange={(data) => handleEditorChange(data)} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item className="btn-row float-right mb-0">
                        <Button type="primary" href={`/${routeName}`}>Back</Button>
                        <Button type="primary" loading={loading} htmlType="submit">Submit</Button>
                    </Form.Item>
                </Form>
            }
        </Card>
    )
}

export default Edit;